import {SellCoveredcallSettingsComponent} from "./sell-coveredcall-settings.component";
import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb/irb-common/interfaces/grid-layout.service";
import {DeleteHeaderComponent} from "@irb/irb-common/components/grid/renderers/delete.header.component";
import {DeleteCellComponent} from "@irb/irb-common/components/grid/renderers/delete.cell.component";
import {NumberTextBoxRendererComponent} from "@irb-common/components/grid/renderers/number-text-box.cell.component";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {OptionToSellCellRenderer} from "../purchase-underlying-settings/option-to-sell-cell-renderer.compoent";

@Injectable({
    providedIn: 'root'
})
export class SellCoveredcallGridLayoutService implements GridLayoutService<SellCoveredcallSettingsComponent> {

    sizeFor: any;

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "underlyingSymbol": 150,
            "optionSymbol": 180,
            "percentOfUnderlyingToCover": 180
        };
    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            'OptionToSellCellRenderer': OptionToSellCellRenderer,
            "NumberTextBoxRendererComponent": NumberTextBoxRendererComponent
        };
    }

    isGridEditable(params: any) {
        return !params.context.componentParent.isReadOnly;
    }

    percentOfUnderlyingToCoverValue(params: any) {
        let val = params.context.componentParent.decimalPipe.transform(params.data.percentOfUnderlyingToCover, '1.2-2');
        return val + " %";
    }

    getColumnDefs(parent: SellCoveredcallSettingsComponent) {
        return [
            {
                headerName: 'Delete All',
                headerComponent: 'DeleteHeaderComponent',
                headerComponentParams: {
                    message: "Remove all items?",
                    proceed: parent.deleteAll.bind(parent),
                    cancel: parent.cancelDelete.bind(parent),
                    disableDelete: parent.isReadOnly
                },
                cellRenderer: 'DeleteCellComponent',
                cellRendererParams: {
                    message: "Remove this item?",
                    proceed: parent.delete.bind(parent),
                    cancel: parent.cancelDelete.bind(parent),
                    disableDelete: this.isGridEditable.bind(this)
                },
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25,
            },
            {
                headerName: 'Underlying Symbol',
                field: 'underlyingSymbol',
                minWidth: this.sizeFor.underlyingSymbol,
                flex: 1,
                sort: "asc",
                resizable: false,
                comparator: this.util.sortString.bind(parent),
                suppressMovable: true,
                editable: false,
                cellHeight: 30,
            },
            {
                headerName: 'Option to sell',
                headerComponentParams: {
                    irbColInfo: `<p>This is the option iRebal will sell against your underlying equity position.</p>`
                },
                field: 'optionSymbol',
                minWidth: this.sizeFor.optionSymbol,
                flex: 1,
                sort: "asc",
                resizable: false,
                comparator: this.util.sortString.bind(parent),
                editable: false,
                cellRenderer: 'OptionToSellCellRenderer',
                suppressMovable: true,
                cellHeight: 30,
            },
            {
                headerName: 'Percent of underlying to cover',
                headerComponentParams: {
                    irbColInfo: `<p>Enter a % of the current underlying security to sell a covered call against. Examples: entering 100% tells iRebal to sell a covered call against the full share quantity that isn't already covered in the account; entering 50% will indicate to sell a covered call against 50% of the share quantity in the account which doesn't have a covered call written against it.</p>`
                },
                field: 'percentOfUnderlyingToCover',
                // valueGetter: this.percentOfUnderlyingToCoverValue,
                // cellEditorFramework: UnderlyingToCoverCellEditor,
                minWidth: this.sizeFor.percentOfUnderlyingToCover,
                flex: 1,
                // editable: this.isGridEditable,
                cellClass: "numberTextBoxCell",
                cellRenderer: "NumberTextBoxRendererComponent",
                cellRendererParams: () => {
                    return {
                        min: 1,
                        max: 100,
                        places: 2,
                        autofocus: true,
                        isPercentage: true,
                        onChange: (params: any, c: any) => {
                            if (params && params.data.percentOfUnderlyingToCover != c.value) {
                                if (!c.isValid) {
                                    if (c.value < 1) {c.value = "1"; c.isValid = true;}
                                    if (c.value > 100) { c.value = "100"; c.isValid = true;}
                                }
                                if (c.isValid) {
                                    params.data.percentOfUnderlyingToCover = parseFloat(c.value);
                                    params.api.redrawRows({rowNodes: [params.node]});
                                }
                            }
                        },
                    };
                },
                resizable: false,
                suppressMovable: true,
                sortable: false
            }
        ];
    }

}
